export default __webpack_public_path__ + "static/media/CarDetailingMediumCut.0cfc075c.webp";